import './import-first';

import React from 'react';
import {AuthProvider} from '../lib/auth/auth-context.jsx';
import Homepage from '../components/homepage/homepage.jsx';
import render from './app-target';

render(
    <AuthProvider>
        <Homepage />
    </AuthProvider>
);
